module.exports = __webpack_public_path__ + "img/Cell-Essence_Launchfilm_lang.dde72da6.jpg";